import script from "./PatientHome.vue?vue&type=script&setup=true&lang=js"
export * from "./PatientHome.vue?vue&type=script&setup=true&lang=js"

import "./PatientHome.vue?vue&type=style&index=0&id=b0f0e7f2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b0f0e7f2"]])

export default __exports__